import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgEyeOpenedGhost = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill={props.color} opacity={0.4}>
      <path d='M3.16 11.732a1 1 0 0 1-1.927.536l-.696-2.5a1 1 0 0 1 1.926-.536zM22.767 12.268a1 1 0 1 1-1.926-.536l.696-2.5a1 1 0 0 1 1.926.536zM7.479 7.795a1 1 0 1 1-1.958.41l-.5-2.393a1 1 0 0 1 1.958-.409zM18.479 8.205a1 1 0 0 1-1.958-.41l.5-2.392a1 1 0 1 1 1.958.41zM13 7a1 1 0 1 1-2 0V4a1 1 0 1 1 2 0z' />
      <path
        fillRule='evenodd'
        d='M12 9.5c-1.231 0-2.43.309-3.31 1.19-.881.88-1.19 2.079-1.19 3.31s.309 2.43 1.19 3.31c.88.881 2.079 1.19 3.31 1.19s2.43-.309 3.31-1.19c.881-.88 1.19-2.079 1.19-3.31s-.309-2.43-1.19-3.31C14.43 9.808 13.232 9.5 12 9.5M10.5 14c0-.769.191-1.07.31-1.19.12-.119.421-.31 1.19-.31s1.07.191 1.19.31c.119.12.31.421.31 1.19s-.191 1.07-.31 1.19c-.12.119-.421.31-1.19.31s-1.07-.191-1.19-.31c-.119-.12-.31-.421-.31-1.19'
        clipRule='evenodd'
      />
    </g>
    <path
      fill={props.color}
      d='M3.11 12.404a1 1 0 1 1-1.829-.808C2.99 7.728 7.67 6 12 6s9.01 1.728 10.719 5.596a1 1 0 1 1-1.83.808C19.653 9.605 16.001 8 12 8s-7.653 1.605-8.89 4.404'
    />
    <path fill={props.color} d='M12 16q2 0 2-2t-2-2-2 2 2 2' />
  </svg>
)
const ForwardRef = forwardRef(SvgEyeOpenedGhost)
export default ForwardRef
